/* eslint-disable jsx-a11y/media-has-caption */
import * as React from 'react'
import cn from 'classnames'
import Image from 'next/image'

import ImgixImage from 'components/ImgixImage/ImgixImage'

import placeholder from '../placeholder.jpeg'
// import Video from 'components/Video/Video'
import PlayButton from '../PlayButton'

import styles from './Featured.module.css'

type FeaturedProps = {
  imageUrl?: string
  videoUrl?: string
  talentName: string
  talentDescription?: string
  price?: string
  size?: 'big' | 'small'
  priceColor?: string
  priority?: boolean
}

const Featured: React.FC<FeaturedProps> = ({
  imageUrl,
  videoUrl,
  talentName,
  talentDescription,
  price,
  size,
  priceColor = '#f8284e',
  priority = false,
}) => {
  const videoPlayer = React.useRef<HTMLVideoElement>(null)
  const [isVideoPlaying, setIsVideoPlaying] = React.useState(false)

  const onPlayButtonClick = () => {
    setIsVideoPlaying(true)
    videoPlayer.current.play()
  }

  const onVideoClick = () => {
    if (videoPlayer.current.paused) {
      videoPlayer.current.play()
    } else {
      videoPlayer.current.pause()
    }
  }

  return (
    <div className={styles.featuredContainer}>
      {!videoUrl &&
        (imageUrl?.includes('imgix') ? (
          <ImgixImage
            className={styles.image}
            src={imageUrl || placeholder}
            alt={talentName}
            layout="fill"
            priority={priority}
          />
        ) : (
          <Image
            className={styles.image}
            src={imageUrl || placeholder}
            alt={talentName}
            layout="fill"
            priority={priority}
          />
        ))}
      {videoUrl && !isVideoPlaying && (
        <PlayButton onClick={onPlayButtonClick} featuredVideo={!!videoUrl} />
      )}

      {videoUrl && (
        // TODO: This should use <Video /> but including it breaks storybook
        <video
          onPause={() => setIsVideoPlaying(false)}
          className={styles.player}
          ref={videoPlayer}
          src={videoUrl}
          poster={imageUrl}
          playsInline
          onClick={onVideoClick}
          onEnded={() => videoPlayer.current.load()}
        />
      )}
      {!isVideoPlaying && (
        <div
          className={cn(styles.content, {
            [styles.bigContent]: size === 'big',
          })}
        >
          {price && (
            <div className={styles.price} style={{ color: priceColor }}>
              {price}
            </div>
          )}
          <div className={styles.title}>{talentName}</div>
          {talentDescription && (
            <div className={styles.description}>{talentDescription}</div>
          )}
        </div>
      )}
    </div>
  )
}

export default Featured
